export default __webpack_public_path__ + "static/media/excella.e9af8509.PNG";